"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pickIndexes = exports.hasKeys = exports.objFromListWith = exports.applyEach = exports.propertyByPath = exports.findNodeById = exports.upperFirstLetter = exports.prependValueToArray = exports.getItemAndIndex = exports.generateID = exports.pickNotEmptyAndNil = exports.pickNotNil = exports.pickNotEmpty = exports.isNotEmptyAndNil = exports.isNotNil = exports.isNotEmpty = exports.isFunction = exports.underscoreCase = exports.fakeItemsFactory = exports.renameKeys = void 0;

var R = _interopRequireWildcard(require("ramda"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Rename keys for passed object.
 *
 * @param {Record<string, string>} keysMap
 * @returns {(objectToRename: Record<string, unknown>) => Record<typeof keysMap[keyof typeof keysMap], unknown>}
 *
 * const rename = renameKeys({ id: 'key', some_property: 'someProperty' });
 *
 * @example
 * rename({ id: 13, some_property: true }); // { key: 13, someProperty: true }
 */
var renameKeys = R.uncurryN(2, function (keysMap) {
  return R.ifElse(R.either(R.isNil, R.isEmpty), R.identity, R.pipe(R.toPairs, R.transpose, R.converge(R.zipObj, [R.pipe(R.head, R.map(function (key) {
    return keysMap[key] || key;
  })), R.last])));
});
exports.renameKeys = renameKeys;
var getDefaultItems = R.curry(function (def, items) {
  return items.length || def;
});

var getFakeItems = function getFakeItems(itemFn, defaultCount) {
  return R.pipe(getDefaultItems(defaultCount), R.range(0), R.map(itemFn));
};

var fakeItemsFactory = function fakeItemsFactory(items, isLoading, itemFn) {
  var defaultCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 5;
  return isLoading ? getFakeItems(itemFn, defaultCount)(items) : items;
};
/**
 * @type {(x0: string) => string}
 */


exports.fakeItemsFactory = fakeItemsFactory;
var underscoreCase = R.compose(R.replace(/\s/g, '_'), R.toLower);
/**
 *
 * @param {*} fn
 * @returns {boolean}
 */

exports.underscoreCase = underscoreCase;

var isFunction = function isFunction(fn) {
  return typeof fn === 'function';
};
/**
 * @return boolean
 */


exports.isFunction = isFunction;
var isNotEmpty = R.complement(R.isEmpty);
/**
 * @return boolean
 */

exports.isNotEmpty = isNotEmpty;
var isNotNil = R.complement(R.isNil);
/**
 * @return boolean
 */

exports.isNotNil = isNotNil;
var isNotEmptyAndNil = R.both(isNotEmpty, isNotNil);
/**
 * @type {<T, U>(obj: T) => U}
 */

exports.isNotEmptyAndNil = isNotEmptyAndNil;
var pickNotEmpty = R.pickBy(isNotEmpty);
/**
 * @type {<T, U>(obj: T) => U}
 */

exports.pickNotEmpty = pickNotEmpty;
var pickNotNil = R.pickBy(isNotNil);
/**
 * @type {<T, U>(obj: T) => U}
 */

exports.pickNotNil = pickNotNil;
var pickNotEmptyAndNil = R.pickBy(isNotEmptyAndNil);
/**
 * Simply analog of uuid
 *
 * @returns {string}
 */

exports.pickNotEmptyAndNil = pickNotEmptyAndNil;

var generateID = function generateID() {
  return "_".concat(Math.random().toString(36).substr(2, 9));
};
/**
 *
 * @param {number} id
 * @param {Record<"id", number>[]} items
 * @returns {[number, typeof items[number]]}
 */


exports.generateID = generateID;

var getItemAndIndex = function getItemAndIndex(id, items) {
  var index = R.findIndex(R.propEq('id', id), items);
  return [index, items[index]];
};
/**
 * @template T
 * @param {*} value
 * @returns {function (T): T}
 */


exports.getItemAndIndex = getItemAndIndex;

var prependValueToArray = function prependValueToArray(value) {
  return R.ifElse(R.complement(R.includes(value)), R.prepend(value), R.identity);
};
/**
 * To Uppercase first char of string.
 *
 * @function
 * @param {string}
 * @returns {string}
 */


exports.prependValueToArray = prependValueToArray;
var upperFirstLetter = R.converge(R.concat, [R.pipe(R.head, R.toUpper), R.slice(1, Infinity)]);
exports.upperFirstLetter = upperFirstLetter;

/**
 *
 * @param {TreeNode[]} trees
 * @param {string | number} id
 * @returns {TreeNode | undefined}
 */
var findNodeById = function findNodeById() {
  var trees = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var id = arguments.length > 1 ? arguments[1] : undefined;
  return trees.reduce(function (foundNode, node) {
    return foundNode || (node.id === Number(id) ? node : findNodeById(node.children, id));
  }, undefined);
};

exports.findNodeById = findNodeById;
var propertyByPath = R.pipe(R.split(/[[\].]/), R.path);
/**
 * Simultaneously apply a list of functions.
 *
 * @param {Array<Function>} fns - Array of functions
 * @param {*} x - Value which be applied to the functions
 */

exports.propertyByPath = propertyByPath;
var applyEach = R.curry(function (fns, x) {
  return R.map(R.applyTo(x), fns);
});
/**
 * Make an object out of a list, with keys derived from each element
 *
 * @example
 * objFromListWith(
 *   R.prop('id'),
 *   [{ id: 'foo', name: 'John' }, { id: 'bar', name: 'Jane' }]
 * )
 * // => { foo: { id: 'foo', name: 'John' }, bar: { id: 'bar', name: 'Jane' } }
 *
 * @param {function(*): string | number} - Function to crate key.
 * @param {Array<*>} - Array to be transformed to object.
 */

exports.applyEach = applyEach;
var objFromListWith = R.curry(function (fn, list) {
  return R.chain(R.zipObj, R.map(fn))(list);
});
/**
 * Check if object has any properties.
 *
 * @example
 * hasKeys({ firstName: 'Bret' })
 * // => true
 *
 * hasKeys({})
 * // => false
 *
 * @param {object} - Object for checking.
 * @return boolean
 */

exports.objFromListWith = objFromListWith;
var hasKeys = R.pipe(R.keys, R.length, Boolean);
/**
 * Pick items from the array by indexes
 *
 * @example
 * pickIndexes([0, 2], ['a', 'b', 'c', 'd']);
 * // => ['a', 'c']
 *
 * @param {Array<number>} - Indexes
 * @param {Array<*>} - Source
 *
 * @returns Array<*>
 */

exports.hasKeys = hasKeys;
var pickIndexes = R.useWith(R.ap, [R.map(R.nth), R.of]);
exports.pickIndexes = pickIndexes;